export default function checkValue(value) {
    switch (value) {
        case null:
        case 'null':
        case undefined:
        case 'undefined':
        case '':
            return false;
        default:
            return true;
    }
}


// WEBPACK FOOTER //
// ./src/_helpers/checkValue.js